"use strict";

var ButtonGroup = require("app/shared/components/ButtonGroup/button-group");
var Button = require("app/shared/components/Button/button");
var Icon = require("app/shared/components/Icon/icon");
var cx = require("classnames");

var ViewTypeFilter = React.createClass({
  getDefaultProps: function() {
    return ({ selected: "listing" });
  },
  componentDidMount: function() {
    this.startTooltips();
  },
  componentDidUpdate: function() {
    this.startTooltips();
  },
  startTooltips: function() {
    $(ReactDOM.findDOMNode(this)).find("[data-toggle='tooltip']").tooltip();
  },
  render: function() {
    return (
      <ButtonGroup>
        <Button href={{url: "/sistema/tarefas/", name: "_self"}} type="filter" className={cx({ selected: this.props.selected === "listing"})}>
          <span className="flex-center-all">
            <Icon custom icon="list"></Icon>
            <span className="hidden-md hidden-sm hidden-xs">Listagem</span>
          </span>
        </Button>
        <Button href={{url: "calendario.php", name: "_self"}} type="filter" className={cx({ selected: this.props.selected === "calendar" })}>
          <span className="flex-center-all">
            <Icon custom icon="calendar"></Icon>
            <span className="hidden-md hidden-sm hidden-xs">Calendário</span>
          </span>
        </Button>
      </ButtonGroup>
    );
  }
});

module.exports = ViewTypeFilter;



// WEBPACK FOOTER //
// ./app/screens/Activity/components/ActivityList/view-type-filter.jsx